import paymentQueries from '@apis/queries/paymentQueries';
import useProject from '@hooks/useProject';
import useProjectId from '@hooks/useProjectId';
import { PaymentMethod as PaymentMethodType, PaymentMethod } from '@models/order';
import { useQuery } from '@tanstack/react-query';

const cafegateId = '0q2r1cxqqwjd1';
const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);

/** 결제 화면에 바로 노출하는 수단. 나머지는 '다른 결제 방법' 시트에서 고른다 */
const MAIN_METHODS: PaymentMethod[] = ['CREDIT_CARD', 'EASY_CARD', 'TOSS_PAY'];

function usePaymentMethods() {
    const { data } = useQuery(paymentQueries.list());
    const projectId = useProjectId();
    const project = useProject();
    const methods: PaymentMethod[] = [...(data?.paymentMethods || [])];
    const showTossPay = projectId === cafegateId;
    const otherMethods = methods
        .filter((method) => !MAIN_METHODS.includes(method))
        .filter((method) => {
            if (!isIos && method === 'APPLE_PAY') {
                return false;
            }
            return method !== 'PREPAID_CARD';
        });

    const creditCardEnabled = methods.includes('CREDIT_CARD');
    const easyCardEnabled = !!project?.features.easyCardEnabled;

    const mainMethods: PaymentMethodType[] = [
        ...(creditCardEnabled ? ['CREDIT_CARD'] as const : []),
        ...(easyCardEnabled ? ['EASY_CARD'] as const : []),
    ];
    return {
        creditCardEnabled: methods.includes('CREDIT_CARD'),
        easyCardEnabled: !!project?.features.easyCardEnabled,
        otherMethods,
        mainMethods,
        showTossPay,
    };
}

export default usePaymentMethods;
